import { Button } from '@/components/core/Button/Button';
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogHeaderDefault } from '@/components/core/Dialog';
import { useTranslation } from '@/hooks/useTranslation';
import type { AssetLabel } from '@/pages/dam/api';

interface DamDeleteTagDialogProps {
    label: AssetLabel;
    isDeleting: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

/**
 * Confirmation before a tag is deleted (Make "Delete tag"; not drawn in the wireframe,
 * D-038). Only the label is deleted; its tags stay on the assets until LAX-10487.
 */
function DamDeleteTagDialog({ label, isDeleting, onConfirm, onClose }: DamDeleteTagDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog open onOpenChange={(open) => !open && !isDeleting && onClose()}>
            <DialogContent variant="small">
                <DialogHeader>
                    <DialogHeaderDefault closeLabel={t('CLOSE')}>{t('DAM.TAGS.DELETE_TITLE')}</DialogHeaderDefault>
                </DialogHeader>
                <DialogBody>
                    <p className="tw-m-0 tw-text-t-sm tw-text-t-primary lg:tw-text-t-base">
                        {t('DAM.TAGS.DELETE_TEXT', { name: label.name, count: label.assetCount.toLocaleString() })}
                    </p>
                </DialogBody>
                <DialogFooter>
                    <Button variant="outline" disabled={isDeleting} onClick={onClose}>{t('CANCEL')}</Button>
                    <Button variant="destructive" loading={isDeleting} disabled={isDeleting} onClick={onConfirm}>
                        {t('DAM.TAGS.CONFIRM')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export { DamDeleteTagDialog };
export type { DamDeleteTagDialogProps };
